export interface Test {
  id: number;
  name: {
    ar: string;
    en: string;
  };
  shortcutName: string;
  category: {
    ar: string;
    en: string;
  };
  description: {
    ar: string;
    en: string;
  };
  preparation: {
    ar: string;
    en: string;
  };
  turnaroundTime: {
    ar: string;
    en: string;
  };
}

export const tests: Test[] = [
  {
    id: 1,
    name: {
      ar: 'تحليل الدم الكامل',
      en: 'Complete Blood Count (CBC)',
    },
    shortcutName: 'CBC',
    category: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'فحص شامل لمكونات الدم بما في ذلك خلايا الدم الحمراء والبيضاء والصفائح الدموية',
      en: 'Comprehensive test of blood components including red blood cells, white blood cells, and platelets',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 2,
    name: {
      ar: 'تحليل وظائف الكبد',
      en: 'Liver Function Tests (LFT)',
    },
    shortcutName: 'LFT',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس إنزيمات وبروتينات الكبد لتقييم صحة الكبد',
      en: 'Measurement of liver enzymes and proteins to assess liver health',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 3,
    name: {
      ar: 'تحليل وظائف الكلى',
      en: 'Kidney Function Tests',
    },
    shortcutName: 'KFT',
    category: {
      ar: 'تحاليل الكلى',
      en: 'Kidney Tests',
    },
    description: {
      ar: 'تقييم كفاءة الكلى في تصفية الدم من الفضلات',
      en: 'Assessment of kidney efficiency in filtering waste from blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 4,
    name: {
      ar: 'تحليل السكر الصائم',
      en: 'Fasting Blood Glucose',
    },
    shortcutName: 'FBS',
    category: {
      ar: 'تحاليل السكر',
      en: 'Diabetes Tests',
    },
    description: {
      ar: 'قياس مستوى السكر في الدم بعد الصيام لتشخيص مرض السكري',
      en: 'Measurement of blood sugar level after fasting to diagnose diabetes',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 5,
    name: {
      ar: 'تحليل السكر التراكمي',
      en: 'Hemoglobin A1C (HbA1c)',
    },
    shortcutName: 'HbA1c',
    category: {
      ar: 'تحاليل السكر',
      en: 'Diabetes Tests',
    },
    description: {
      ar: 'قياس متوسط مستوى السكر في الدم خلال الشهرين أو الثلاثة أشهر الماضية',
      en: 'Measurement of average blood sugar level over the past 2-3 months',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 6,
    name: {
      ar: 'تحليل الدهون الكامل',
      en: 'Lipid Profile',
    },
    shortcutName: 'Lipid',
    category: {
      ar: 'تحاليل القلب والكولسترول',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس الكولسترول والدهون الثلاثية لتقييم خطر الإصابة بأمراض القلب',
      en: 'Measurement of cholesterol and triglycerides to assess cardiovascular risk',
    },
    preparation: {
      ar: 'صيام 12 ساعة',
      en: '12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 7,
    name: {
      ar: 'تحليل وظائف الغدة الدرقية',
      en: 'Thyroid Function Tests',
    },
    shortcutName: 'TFT',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس هرمونات الغدة الدرقية لتقييم وظائفها',
      en: 'Measurement of thyroid hormones to assess thyroid function',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 8,
    name: {
      ar: 'تحليل البول الكامل',
      en: 'Urinalysis',
    },
    shortcutName: 'UA',
    category: {
      ar: 'تحاليل البول',
      en: 'Urine Tests',
    },
    description: {
      ar: 'فحص شامل للبول للكشف عن علامات الأمراض أو العدوى',
      en: 'Comprehensive examination of urine for signs of disease or infection',
    },
    preparation: {
      ar: 'عينة بول منتصف التبول',
      en: 'Mid-stream urine sample',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 9,
    name: {
      ar: 'تحليل زمن البروثرومبين',
      en: 'Prothrombin Time (PT)',
    },
    shortcutName: 'PT',
    category: {
      ar: 'تحاليل التجلط',
      en: 'Coagulation Tests',
    },
    description: {
      ar: 'قياس الوقت اللازم لتجلط الدم للمساعدة في تشخيص اضطرابات النزيف',
      en: 'Measurement of time needed for blood to clot, aiding in diagnosing bleeding disorders',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 10,
    name: {
      ar: 'تحليل الأملاح المعدنية',
      en: 'Electrolyte Panel',
    },
    shortcutName: 'Electrolytes',
    category: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'قياس مستويات الأملاح المعدنية مثل الصوديوم والبوتاسيوم لتقييم توازن السوائل',
      en: 'Measurement of electrolyte levels like sodium and potassium to assess fluid balance',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 11,
    name: {
      ar: 'تحليل فيتامين د',
      en: 'Vitamin D Test',
    },
    shortcutName: 'Vit D',
    category: {
      ar: 'تحاليل الفيتامينات',
      en: 'Vitamin Tests',
    },
    description: {
      ar: 'قياس مستوى فيتامين د في الدم المهم لصحة العظام',
      en: 'Measurement of vitamin D levels in blood, important for bone health',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 12,
    name: {
      ar: 'تحليل الحديد',
      en: 'Iron Studies',
    },
    shortcutName: 'Iron',
    category: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'قياس مستويات الحديد في الدم لتشخيص حالات مثل فقر الدم',
      en: 'Measurement of iron levels to diagnose conditions like anemia',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 13,
    name: {
      ar: 'تحليل البروتين التفاعلي C',
      en: 'C-Reactive Protein (CRP)',
    },
    shortcutName: 'CRP',
    category: {
      ar: 'تحاليل الالتهابات',
      en: 'Inflammation Tests',
    },
    description: {
      ar: 'قياس مستوى الالتهاب في الجسم',
      en: 'Measurement of inflammation levels in the body',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 14,
    name: {
      ar: 'تحليل سرعة ترسيب الدم',
      en: 'Erythrocyte Sedimentation Rate (ESR)',
    },
    shortcutName: 'ESR',
    category: {
      ar: 'تحاليل الالتهابات',
      en: 'Inflammation Tests',
    },
    description: {
      ar: 'فحص للكشف عن الالتهابات في الجسم',
      en: 'Test to detect inflammation in the body',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 15,
    name: {
      ar: 'تحليل الهرمونات الجنسية',
      en: 'Sex Hormones Panel',
    },
    shortcutName: 'Sex Hormones',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس مستويات الهرمونات الجنسية مثل الإستروجين والتستوستيرون',
      en: 'Measurement of sex hormone levels like estrogen and testosterone',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 16,
    name: {
      ar: 'تحليل فيروسات الكبد',
      en: 'Hepatitis Panel',
    },
    shortcutName: 'Hepatitis',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'الكشف عن عدوى فيروسات الكبد (أ، ب، ج)',
      en: 'Detection of hepatitis virus infections (A, B, C)',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48-72 ساعة',
      en: '48-72 hours',
    },
  },
  {
    id: 17,
    name: {
      ar: 'تحليل فيروس نقص المناعة',
      en: 'HIV Test',
    },
    shortcutName: 'HIV',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'فحص للكشف عن فيروس نقص المناعة البشرية',
      en: 'Test to detect human immunodeficiency virus',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48-72 ساعة',
      en: '48-72 hours',
    },
  },
  {
    id: 18,
    name: {
      ar: 'تحليل الزهري',
      en: 'Syphilis Test',
    },
    shortcutName: 'VDRL',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'الكشف عن عدوى الزهري',
      en: 'Detection of syphilis infection',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 19,
    name: {
      ar: 'تحليل السل',
      en: 'Tuberculosis (TB) Test',
    },
    shortcutName: 'TB',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'الكشف عن عدوى السل',
      en: 'Detection of tuberculosis infection',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48-72 ساعة',
      en: '48-72 hours',
    },
  },
  {
    id: 20,
    name: {
      ar: 'تحليل البراز',
      en: 'Stool Analysis',
    },
    shortcutName: 'Stool',
    category: {
      ar: 'تحاليل البراز',
      en: 'Stool Tests',
    },
    description: {
      ar: 'فحص البراز للكشف عن مشاكل الجهاز الهضمي أو العدوى أو الدم',
      en: 'Examination of stool for digestive tract issues, infections, or blood',
    },
    preparation: {
      ar: 'عينة براز طازجة',
      en: 'Fresh stool sample',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 21,
    name: {
      ar: 'تحليل الحمل',
      en: 'Pregnancy Test',
    },
    shortcutName: 'HCG',
    category: {
      ar: 'تحاليل الحمل',
      en: 'Pregnancy Tests',
    },
    description: {
      ar: 'فحص للكشف عن هرمون الحمل في الدم أو البول',
      en: 'Test to detect pregnancy hormone in blood or urine',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 22,
    name: {
      ar: 'تحليل مستضد البروستاتا',
      en: 'Prostate-Specific Antigen (PSA)',
    },
    shortcutName: 'PSA',
    category: {
      ar: 'تحاليل الأورام',
      en: 'Tumor Markers',
    },
    description: {
      ar: 'فحص للكشف عن مشاكل البروستاتا',
      en: 'Test to screen for prostate issues',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 23,
    name: {
      ar: 'تحليل الميكروبات',
      en: 'Culture and Sensitivity',
    },
    shortcutName: 'C&S',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'زرع عينة للكشف عن البكتيريا أو الفطريات وتحديد المضاد الحيوي المناسب',
      en: 'Culture of sample to detect bacteria or fungi and determine appropriate antibiotic',
    },
    preparation: {
      ar: 'حسب نوع العينة',
      en: 'Depends on sample type',
    },
    turnaroundTime: {
      ar: '3-5 أيام',
      en: '3-5 days',
    },
  },
  {
    id: 24,
    name: {
      ar: 'تحليل فيتامين ب12',
      en: 'Vitamin B12 Test',
    },
    shortcutName: 'Vit B12',
    category: {
      ar: 'تحاليل الفيتامينات',
      en: 'Vitamin Tests',
    },
    description: {
      ar: 'قياس مستوى فيتامين ب12 في الدم',
      en: 'Measurement of vitamin B12 levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 25,
    name: {
      ar: 'تحليل حمض الفوليك',
      en: 'Folic Acid Test',
    },
    shortcutName: 'Folate',
    category: {
      ar: 'تحاليل الفيتامينات',
      en: 'Vitamin Tests',
    },
    description: {
      ar: 'قياس مستوى حمض الفوليك في الدم',
      en: 'Measurement of folic acid levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 26,
    name: {
      ar: 'تحليل البيليروبين',
      en: 'Bilirubin Test',
    },
    shortcutName: 'Bilirubin',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس مستوى البيليروبين لتقييم وظائف الكبد',
      en: 'Measurement of bilirubin levels to assess liver function',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 27,
    name: {
      ar: 'تحليل الألبومين',
      en: 'Albumin Test',
    },
    shortcutName: 'Albumin',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس مستوى الألبومين في الدم لتقييم وظائف الكبد والكلى',
      en: 'Measurement of albumin levels to assess liver and kidney function',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 28,
    name: {
      ar: 'تحليل الكرياتينين',
      en: 'Creatinine Test',
    },
    shortcutName: 'Creatinine',
    category: {
      ar: 'تحاليل الكلى',
      en: 'Kidney Tests',
    },
    description: {
      ar: 'قياس مستوى الكرياتينين لتقييم وظائف الكلى',
      en: 'Measurement of creatinine levels to assess kidney function',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 29,
    name: {
      ar: 'تحليل اليوريا',
      en: 'Urea Test',
    },
    shortcutName: 'Urea',
    category: {
      ar: 'تحاليل الكلى',
      en: 'Kidney Tests',
    },
    description: {
      ar: 'قياس مستوى اليوريا في الدم لتقييم وظائف الكلى',
      en: 'Measurement of urea levels to assess kidney function',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 30,
    name: {
      ar: 'تحليل حمض اليوريك',
      en: 'Uric Acid Test',
    },
    shortcutName: 'Uric Acid',
    category: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'قياس مستوى حمض اليوريك للكشف عن النقرس',
      en: 'Measurement of uric acid levels to detect gout',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 31,
    name: {
      ar: 'تحليل إنزيمات القلب',
      en: 'Cardiac Enzymes',
    },
    shortcutName: 'Cardiac Enzymes',
    category: {
      ar: 'تحاليل القلب',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس إنزيمات القلب للكشف عن النوبات القلبية',
      en: 'Measurement of cardiac enzymes to detect heart attacks',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 32,
    name: {
      ar: 'تحليل الهيموجلوبين السكري',
      en: 'Glycated Hemoglobin',
    },
    shortcutName: 'HbA1c',
    category: {
      ar: 'تحاليل السكر',
      en: 'Diabetes Tests',
    },
    description: {
      ar: 'قياس نسبة الهيموجلوبين المرتبط بالسكر',
      en: 'Measurement of hemoglobin bound to sugar',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 33,
    name: {
      ar: 'تحليل السكر بعد الأكل',
      en: 'Postprandial Blood Glucose',
    },
    shortcutName: 'PPBS',
    category: {
      ar: 'تحاليل السكر',
      en: 'Diabetes Tests',
    },
    description: {
      ar: 'قياس مستوى السكر في الدم بعد تناول الطعام بساعتين',
      en: 'Measurement of blood sugar level 2 hours after eating',
    },
    preparation: {
      ar: 'صيام 8 ساعات ثم تناول وجبة',
      en: '8 hours fasting then meal',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 34,
    name: {
      ar: 'تحليل منحنى السكر',
      en: 'Glucose Tolerance Test',
    },
    shortcutName: 'GTT',
    category: {
      ar: 'تحاليل السكر',
      en: 'Diabetes Tests',
    },
    description: {
      ar: 'فحص لتشخيص سكري الحمل أو عدم تحمل الجلوكوز',
      en: 'Test to diagnose gestational diabetes or glucose intolerance',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 35,
    name: {
      ar: 'تحليل بكتيريا المعدة',
      en: 'H. Pylori Test',
    },
    shortcutName: 'H. Pylori',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'الكشف عن عدوى بكتيريا هيليكوباكتر بيلوري في المعدة',
      en: 'Detection of Helicobacter pylori infection in the stomach',
    },
    preparation: {
      ar: 'صيام 8 ساعات',
      en: '8 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 36,
    name: {
      ar: 'تحليل زمن التجلط',
      en: 'Coagulation Time',
    },
    shortcutName: 'CT',
    category: {
      ar: 'تحاليل التجلط',
      en: 'Coagulation Tests',
    },
    description: {
      ar: 'قياس الوقت اللازم لتجلط الدم',
      en: 'Measurement of time needed for blood to clot',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 37,
    name: {
      ar: 'تحليل زمن الثرومبوبلاستين',
      en: 'Partial Thromboplastin Time (PTT)',
    },
    shortcutName: 'PTT',
    category: {
      ar: 'تحاليل التجلط',
      en: 'Coagulation Tests',
    },
    description: {
      ar: 'قياس وظيفة التجلط في الدم',
      en: 'Measurement of blood clotting function',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 38,
    name: {
      ar: 'تحليل الدهون الثلاثية',
      en: 'Triglycerides',
    },
    shortcutName: 'TG',
    category: {
      ar: 'تحاليل القلب والكولسترول',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس مستوى الدهون الثلاثية في الدم',
      en: 'Measurement of triglyceride levels in blood',
    },
    preparation: {
      ar: 'صيام 12 ساعة',
      en: '12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 39,
    name: {
      ar: 'تحليل الكولسترول الكلي',
      en: 'Total Cholesterol',
    },
    shortcutName: 'TC',
    category: {
      ar: 'تحاليل القلب والكولسترول',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس مستوى الكولسترول الكلي في الدم',
      en: 'Measurement of total cholesterol levels in blood',
    },
    preparation: {
      ar: 'صيام 12 ساعة',
      en: '12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 40,
    name: {
      ar: 'تحليل الكولسترول النافع',
      en: 'HDL Cholesterol',
    },
    shortcutName: 'HDL',
    category: {
      ar: 'تحاليل القلب والكولسترول',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس مستوى الكولسترول عالي الكثافة (النافع)',
      en: 'Measurement of high-density lipoprotein (good) cholesterol',
    },
    preparation: {
      ar: 'صيام 12 ساعة',
      en: '12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 41,
    name: {
      ar: 'تحليل الكولسترول الضار',
      en: 'LDL Cholesterol',
    },
    shortcutName: 'LDL',
    category: {
      ar: 'تحاليل القلب والكولسترول',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس مستوى الكولسترول منخفض الكثافة (الضار)',
      en: 'Measurement of low-density lipoprotein (bad) cholesterol',
    },
    preparation: {
      ar: 'صيام 12 ساعة',
      en: '12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 42,
    name: {
      ar: 'تحليل هرمون TSH',
      en: 'TSH (Thyroid Stimulating Hormone)',
    },
    shortcutName: 'TSH',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس هرمون تحفيز الغدة الدرقية',
      en: 'Measurement of thyroid stimulating hormone',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 43,
    name: {
      ar: 'تحليل هرمون T3',
      en: 'T3 (Triiodothyronine)',
    },
    shortcutName: 'T3',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس هرمون ثلاثي يود الثيرونين',
      en: 'Measurement of triiodothyronine hormone',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 44,
    name: {
      ar: 'تحليل هرمون T4',
      en: 'T4 (Thyroxine)',
    },
    shortcutName: 'T4',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس هرمون الثيروكسين',
      en: 'Measurement of thyroxine hormone',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 45,
    name: {
      ar: 'تحليل هرمون التستوستيرون',
      en: 'Testosterone',
    },
    shortcutName: 'Testosterone',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس مستوى هرمون التستوستيرون في الدم',
      en: 'Measurement of testosterone levels in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 46,
    name: {
      ar: 'تحليل هرمون الإستروجين',
      en: 'Estrogen',
    },
    shortcutName: 'Estrogen',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس مستوى هرمون الإستروجين في الدم',
      en: 'Measurement of estrogen levels in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 47,
    name: {
      ar: 'تحليل هرمون البروجسترون',
      en: 'Progesterone',
    },
    shortcutName: 'Progesterone',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس مستوى هرمون البروجسترون في الدم',
      en: 'Measurement of progesterone levels in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 48,
    name: {
      ar: 'تحليل هرمون النمو',
      en: 'Growth Hormone (GH)',
    },
    shortcutName: 'GH',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس مستوى هرمون النمو في الدم',
      en: 'Measurement of growth hormone levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 49,
    name: {
      ar: 'تحليل هرمون الكورتيزول',
      en: 'Cortisol',
    },
    shortcutName: 'Cortisol',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس مستوى هرمون الكورتيزول في الدم',
      en: 'Measurement of cortisol levels in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 50,
    name: {
      ar: 'تحليل هرمون البرولاكتين',
      en: 'Prolactin',
    },
    shortcutName: 'Prolactin',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس مستوى هرمون البرولاكتين في الدم',
      en: 'Measurement of prolactin levels in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 51,
    name: {
      ar: 'تحليل إنزيمات الكبد',
      en: 'Liver Enzymes (ALT, AST)',
    },
    shortcutName: 'ALT/AST',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس إنزيمات الكبد (ALT و AST) لتقييم صحة الكبد',
      en: 'Measurement of liver enzymes (ALT and AST) to assess liver health',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 52,
    name: {
      ar: 'تحليل إنزيم الفوسفاتاز القلوي',
      en: 'Alkaline Phosphatase (ALP)',
    },
    shortcutName: 'ALP',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس إنزيم الفوسفاتاز القلوي لتقييم وظائف الكبد والعظام',
      en: 'Measurement of alkaline phosphatase to assess liver and bone function',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 53,
    name: {
      ar: 'تحليل جاما جلوتاميل ترانسفيراز',
      en: 'Gamma-Glutamyl Transferase (GGT)',
    },
    shortcutName: 'GGT',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس إنزيم GGT لتقييم صحة الكبد',
      en: 'Measurement of GGT enzyme to assess liver health',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 54,
    name: {
      ar: 'تحليل وظائف الكلى الكامل',
      en: 'Complete Kidney Function Panel',
    },
    shortcutName: 'KFT Panel',
    category: {
      ar: 'تحاليل الكلى',
      en: 'Kidney Tests',
    },
    description: {
      ar: 'فحص شامل لوظائف الكلى يشمل الكرياتينين واليوريا والأملاح',
      en: 'Comprehensive kidney function test including creatinine, urea, and electrolytes',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 55,
    name: {
      ar: 'تحليل وظائف الكبد الكامل',
      en: 'Complete Liver Function Panel',
    },
    shortcutName: 'LFT Panel',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'فحص شامل لوظائف الكبد يشمل جميع الإنزيمات والبروتينات',
      en: 'Comprehensive liver function test including all enzymes and proteins',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  // Additional Blood Tests
  {
    id: 56,
    name: {
      ar: 'تحليل فصيلة الدم',
      en: 'Blood Group Test',
    },
    shortcutName: 'Blood Group',
    category: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'تحديد فصيلة الدم ونوع العامل الريزيسي',
      en: 'Determination of blood group and Rh factor type',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 57,
    name: {
      ar: 'تحليل سرعة الترسيب',
      en: 'Sedimentation Rate',
    },
    shortcutName: 'SR',
    category: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'قياس سرعة ترسيب خلايا الدم الحمراء',
      en: 'Measurement of red blood cell sedimentation rate',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 58,
    name: {
      ar: 'تحليل الهيموجلوبين',
      en: 'Hemoglobin Test',
    },
    shortcutName: 'Hb',
    category: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'قياس مستوى الهيموجلوبين في الدم',
      en: 'Measurement of hemoglobin levels in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 59,
    name: {
      ar: 'تحليل الهيماتوكريت',
      en: 'Hematocrit Test',
    },
    shortcutName: 'HCT',
    category: {
      ar: 'تحاليل الدم',
      en: 'Blood Tests',
    },
    description: {
      ar: 'قياس نسبة خلايا الدم الحمراء في الدم',
      en: 'Measurement of red blood cell percentage in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  // Additional Liver Tests
  {
    id: 60,
    name: {
      ar: 'تحليل إنزيم AST',
      en: 'AST (Aspartate Aminotransferase)',
    },
    shortcutName: 'AST',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس إنزيم AST لتقييم صحة الكبد',
      en: 'Measurement of AST enzyme to assess liver health',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 61,
    name: {
      ar: 'تحليل إنزيم ALT',
      en: 'ALT (Alanine Aminotransferase)',
    },
    shortcutName: 'ALT',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس إنزيم ALT لتقييم صحة الكبد',
      en: 'Measurement of ALT enzyme to assess liver health',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 62,
    name: {
      ar: 'تحليل البروتين الكلي',
      en: 'Total Protein',
    },
    shortcutName: 'TP',
    category: {
      ar: 'تحاليل الكبد',
      en: 'Liver Tests',
    },
    description: {
      ar: 'قياس مستوى البروتين الكلي في الدم',
      en: 'Measurement of total protein levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  // Additional Kidney Tests
  {
    id: 63,
    name: {
      ar: 'تحليل تصفية الكرياتينين',
      en: 'Creatinine Clearance',
    },
    shortcutName: 'CrCl',
    category: {
      ar: 'تحاليل الكلى',
      en: 'Kidney Tests',
    },
    description: {
      ar: 'قياس معدل تصفية الكرياتينين لتقييم وظائف الكلى',
      en: 'Measurement of creatinine clearance rate to assess kidney function',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 64,
    name: {
      ar: 'تحليل البولينا',
      en: 'BUN (Blood Urea Nitrogen)',
    },
    shortcutName: 'BUN',
    category: {
      ar: 'تحاليل الكلى',
      en: 'Kidney Tests',
    },
    description: {
      ar: 'قياس نيتروجين اليوريا في الدم لتقييم وظائف الكلى',
      en: 'Measurement of blood urea nitrogen to assess kidney function',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 65,
    name: {
      ar: 'تحليل الكالسيوم',
      en: 'Calcium Test',
    },
    shortcutName: 'Ca',
    category: {
      ar: 'تحاليل الكلى',
      en: 'Kidney Tests',
    },
    description: {
      ar: 'قياس مستوى الكالسيوم في الدم',
      en: 'Measurement of calcium levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 66,
    name: {
      ar: 'تحليل الفوسفور',
      en: 'Phosphorus Test',
    },
    shortcutName: 'Phosphorus',
    category: {
      ar: 'تحاليل الكلى',
      en: 'Kidney Tests',
    },
    description: {
      ar: 'قياس مستوى الفوسفور في الدم',
      en: 'Measurement of phosphorus levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  // Additional Diabetes Tests
  {
    id: 67,
    name: {
      ar: 'تحليل السكر العشوائي',
      en: 'Random Blood Glucose',
    },
    shortcutName: 'RBG',
    category: {
      ar: 'تحاليل السكر',
      en: 'Diabetes Tests',
    },
    description: {
      ar: 'قياس مستوى السكر في الدم في أي وقت',
      en: 'Measurement of blood sugar level at any time',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 68,
    name: {
      ar: 'تحليل الأنسولين',
      en: 'Insulin Test',
    },
    shortcutName: 'Insulin',
    category: {
      ar: 'تحاليل السكر',
      en: 'Diabetes Tests',
    },
    description: {
      ar: 'قياس مستوى الأنسولين في الدم',
      en: 'Measurement of insulin levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 69,
    name: {
      ar: 'تحليل الببتيد C',
      en: 'C-Peptide Test',
    },
    shortcutName: 'C-Peptide',
    category: {
      ar: 'تحاليل السكر',
      en: 'Diabetes Tests',
    },
    description: {
      ar: 'قياس مستوى الببتيد C لتقييم إنتاج الأنسولين',
      en: 'Measurement of C-peptide levels to assess insulin production',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  // Additional Hormone Tests
  {
    id: 70,
    name: {
      ar: 'تحليل هرمون FSH',
      en: 'FSH (Follicle Stimulating Hormone)',
    },
    shortcutName: 'FSH',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس هرمون تحفيز الجريبات',
      en: 'Measurement of follicle stimulating hormone',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 71,
    name: {
      ar: 'تحليل هرمون LH',
      en: 'LH (Luteinizing Hormone)',
    },
    shortcutName: 'LH',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس هرمون اللوتين',
      en: 'Measurement of luteinizing hormone',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 72,
    name: {
      ar: 'تحليل هرمون ACTH',
      en: 'ACTH (Adrenocorticotropic Hormone)',
    },
    shortcutName: 'ACTH',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس هرمون قشر الكظر',
      en: 'Measurement of adrenocorticotropic hormone',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 73,
    name: {
      ar: 'تحليل هرمون DHEA',
      en: 'DHEA (Dehydroepiandrosterone)',
    },
    shortcutName: 'DHEA',
    category: {
      ar: 'تحاليل الهرمونات',
      en: 'Hormone Tests',
    },
    description: {
      ar: 'قياس هرمون DHEA',
      en: 'Measurement of DHEA hormone',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  // Additional Urine Tests
  {
    id: 74,
    name: {
      ar: 'تحليل مزرعة البول',
      en: 'Urine Culture',
    },
    shortcutName: 'Urine C&S',
    category: {
      ar: 'تحاليل البول',
      en: 'Urine Tests',
    },
    description: {
      ar: 'زرع عينة البول للكشف عن البكتيريا',
      en: 'Culture of urine sample to detect bacteria',
    },
    preparation: {
      ar: 'عينة بول منتصف التبول',
      en: 'Mid-stream urine sample',
    },
    turnaroundTime: {
      ar: '3-5 أيام',
      en: '3-5 days',
    },
  },
  {
    id: 75,
    name: {
      ar: 'تحليل البروتين في البول',
      en: 'Urine Protein Test',
    },
    shortcutName: 'Urine Protein',
    category: {
      ar: 'تحاليل البول',
      en: 'Urine Tests',
    },
    description: {
      ar: 'قياس مستوى البروتين في البول',
      en: 'Measurement of protein levels in urine',
    },
    preparation: {
      ar: 'عينة بول منتصف التبول',
      en: 'Mid-stream urine sample',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 76,
    name: {
      ar: 'تحليل السكر في البول',
      en: 'Urine Glucose Test',
    },
    shortcutName: 'Urine Glucose',
    category: {
      ar: 'تحاليل البول',
      en: 'Urine Tests',
    },
    description: {
      ar: 'قياس مستوى السكر في البول',
      en: 'Measurement of glucose levels in urine',
    },
    preparation: {
      ar: 'عينة بول منتصف التبول',
      en: 'Mid-stream urine sample',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  // Additional Coagulation Tests
  {
    id: 77,
    name: {
      ar: 'تحليل الفيبرينوجين',
      en: 'Fibrinogen Test',
    },
    shortcutName: 'Fibrinogen',
    category: {
      ar: 'تحاليل التجلط',
      en: 'Coagulation Tests',
    },
    description: {
      ar: 'قياس مستوى الفيبرينوجين في الدم',
      en: 'Measurement of fibrinogen levels in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 78,
    name: {
      ar: 'تحليل D-Dimer',
      en: 'D-Dimer Test',
    },
    shortcutName: 'D-Dimer',
    category: {
      ar: 'تحاليل التجلط',
      en: 'Coagulation Tests',
    },
    description: {
      ar: 'قياس D-Dimer للكشف عن الجلطات',
      en: 'Measurement of D-Dimer to detect blood clots',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 79,
    name: {
      ar: 'تحليل INR',
      en: 'INR (International Normalized Ratio)',
    },
    shortcutName: 'INR',
    category: {
      ar: 'تحاليل التجلط',
      en: 'Coagulation Tests',
    },
    description: {
      ar: 'قياس النسبة المعيارية الدولية لتجلط الدم',
      en: 'Measurement of international normalized ratio for blood clotting',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  // Additional Vitamin Tests
  {
    id: 80,
    name: {
      ar: 'تحليل فيتامين أ',
      en: 'Vitamin A Test',
    },
    shortcutName: 'Vit A',
    category: {
      ar: 'تحاليل الفيتامينات',
      en: 'Vitamin Tests',
    },
    description: {
      ar: 'قياس مستوى فيتامين أ في الدم',
      en: 'Measurement of vitamin A levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 81,
    name: {
      ar: 'تحليل فيتامين هـ',
      en: 'Vitamin E Test',
    },
    shortcutName: 'Vit E',
    category: {
      ar: 'تحاليل الفيتامينات',
      en: 'Vitamin Tests',
    },
    description: {
      ar: 'قياس مستوى فيتامين هـ في الدم',
      en: 'Measurement of vitamin E levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 82,
    name: {
      ar: 'تحليل فيتامين ك',
      en: 'Vitamin K Test',
    },
    shortcutName: 'Vit K',
    category: {
      ar: 'تحاليل الفيتامينات',
      en: 'Vitamin Tests',
    },
    description: {
      ar: 'قياس مستوى فيتامين ك في الدم',
      en: 'Measurement of vitamin K levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  // Additional Inflammation Tests
  {
    id: 83,
    name: {
      ar: 'تحليل البروتين التفاعلي C عالي الحساسية',
      en: 'High-Sensitivity CRP (hs-CRP)',
    },
    shortcutName: 'hs-CRP',
    category: {
      ar: 'تحاليل الالتهابات',
      en: 'Inflammation Tests',
    },
    description: {
      ar: 'قياس البروتين التفاعلي C عالي الحساسية للكشف عن الالتهابات',
      en: 'Measurement of high-sensitivity C-reactive protein to detect inflammation',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 84,
    name: {
      ar: 'تحليل الفيريتين',
      en: 'Ferritin Test',
    },
    shortcutName: 'Ferritin',
    category: {
      ar: 'تحاليل الالتهابات',
      en: 'Inflammation Tests',
    },
    description: {
      ar: 'قياس مستوى الفيريتين في الدم',
      en: 'Measurement of ferritin levels in blood',
    },
    preparation: {
      ar: 'صيام 8-12 ساعة',
      en: '8-12 hours fasting',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 85,
    name: {
      ar: 'تحليل البروكالسيتونين',
      en: 'Procalcitonin Test',
    },
    shortcutName: 'PCT',
    category: {
      ar: 'تحاليل الالتهابات',
      en: 'Inflammation Tests',
    },
    description: {
      ar: 'قياس البروكالسيتونين للكشف عن الالتهابات البكتيرية',
      en: 'Measurement of procalcitonin to detect bacterial infections',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  // Additional Infection Tests
  {
    id: 86,
    name: {
      ar: 'تحليل فيروس سي',
      en: 'Hepatitis C Test',
    },
    shortcutName: 'HCV',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'الكشف عن فيروس التهاب الكبد الوبائي سي',
      en: 'Detection of hepatitis C virus',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48-72 ساعة',
      en: '48-72 hours',
    },
  },
  {
    id: 87,
    name: {
      ar: 'تحليل فيروس بي',
      en: 'Hepatitis B Test',
    },
    shortcutName: 'HBV',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'الكشف عن فيروس التهاب الكبد الوبائي بي',
      en: 'Detection of hepatitis B virus',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48-72 ساعة',
      en: '48-72 hours',
    },
  },
  {
    id: 88,
    name: {
      ar: 'تحليل فيروس أ',
      en: 'Hepatitis A Test',
    },
    shortcutName: 'HAV',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'الكشف عن فيروس التهاب الكبد الوبائي أ',
      en: 'Detection of hepatitis A virus',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48-72 ساعة',
      en: '48-72 hours',
    },
  },
  {
    id: 89,
    name: {
      ar: 'تحليل مزرعة الدم',
      en: 'Blood Culture',
    },
    shortcutName: 'Blood C&S',
    category: {
      ar: 'تحاليل العدوى',
      en: 'Infection Tests',
    },
    description: {
      ar: 'زرع عينة الدم للكشف عن البكتيريا',
      en: 'Culture of blood sample to detect bacteria',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '3-5 أيام',
      en: '3-5 days',
    },
  },
  // Additional Stool Tests
  {
    id: 90,
    name: {
      ar: 'تحليل الدم الخفي في البراز',
      en: 'Fecal Occult Blood',
    },
    shortcutName: 'FOB',
    category: {
      ar: 'تحاليل البراز',
      en: 'Stool Tests',
    },
    description: {
      ar: 'الكشف عن الدم الخفي في البراز',
      en: 'Detection of hidden blood in stool',
    },
    preparation: {
      ar: 'عينة براز طازجة',
      en: 'Fresh stool sample',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 91,
    name: {
      ar: 'تحليل الطفيليات في البراز',
      en: 'Stool Parasites',
    },
    shortcutName: 'Stool O&P',
    category: {
      ar: 'تحاليل البراز',
      en: 'Stool Tests',
    },
    description: {
      ar: 'فحص البراز للكشف عن الطفيليات',
      en: 'Examination of stool for parasites',
    },
    preparation: {
      ar: 'عينة براز طازجة',
      en: 'Fresh stool sample',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
  {
    id: 92,
    name: {
      ar: 'تحليل مزرعة البراز',
      en: 'Stool Culture',
    },
    shortcutName: 'Stool C&S',
    category: {
      ar: 'تحاليل البراز',
      en: 'Stool Tests',
    },
    description: {
      ar: 'زرع عينة البراز للكشف عن البكتيريا',
      en: 'Culture of stool sample to detect bacteria',
    },
    preparation: {
      ar: 'عينة براز طازجة',
      en: 'Fresh stool sample',
    },
    turnaroundTime: {
      ar: '3-5 أيام',
      en: '3-5 days',
    },
  },
  // Additional Pregnancy Tests
  {
    id: 93,
    name: {
      ar: 'تحليل هرمون الحمل الكمي',
      en: 'Quantitative HCG',
    },
    shortcutName: 'HCG Q',
    category: {
      ar: 'تحاليل الحمل',
      en: 'Pregnancy Tests',
    },
    description: {
      ar: 'قياس كمية هرمون الحمل في الدم',
      en: 'Measurement of pregnancy hormone quantity in blood',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 94,
    name: {
      ar: 'تحليل هرمون الحمل النوعي',
      en: 'Qualitative HCG',
    },
    shortcutName: 'HCG Qual',
    category: {
      ar: 'تحاليل الحمل',
      en: 'Pregnancy Tests',
    },
    description: {
      ar: 'فحص نوعي لهرمون الحمل',
      en: 'Qualitative test for pregnancy hormone',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 95,
    name: {
      ar: 'تحليل هرمون البروجسترون في الحمل',
      en: 'Pregnancy Progesterone',
    },
    shortcutName: 'Preg Progesterone',
    category: {
      ar: 'تحاليل الحمل',
      en: 'Pregnancy Tests',
    },
    description: {
      ar: 'قياس هرمون البروجسترون أثناء الحمل',
      en: 'Measurement of progesterone during pregnancy',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  // Additional Tumor Markers
  {
    id: 96,
    name: {
      ar: 'تحليل CEA',
      en: 'CEA (Carcinoembryonic Antigen)',
    },
    shortcutName: 'CEA',
    category: {
      ar: 'تحاليل الأورام',
      en: 'Tumor Markers',
    },
    description: {
      ar: 'قياس مستضد السرطان الجنيني',
      en: 'Measurement of carcinoembryonic antigen',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 97,
    name: {
      ar: 'تحليل CA 19-9',
      en: 'CA 19-9 Test',
    },
    shortcutName: 'CA 19-9',
    category: {
      ar: 'تحاليل الأورام',
      en: 'Tumor Markers',
    },
    description: {
      ar: 'قياس علامة الورم CA 19-9',
      en: 'Measurement of tumor marker CA 19-9',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 98,
    name: {
      ar: 'تحليل CA 125',
      en: 'CA 125 Test',
    },
    shortcutName: 'CA 125',
    category: {
      ar: 'تحاليل الأورام',
      en: 'Tumor Markers',
    },
    description: {
      ar: 'قياس علامة الورم CA 125',
      en: 'Measurement of tumor marker CA 125',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  {
    id: 99,
    name: {
      ar: 'تحليل AFP',
      en: 'AFP (Alpha-Fetoprotein)',
    },
    shortcutName: 'AFP',
    category: {
      ar: 'تحاليل الأورام',
      en: 'Tumor Markers',
    },
    description: {
      ar: 'قياس بروتين ألفا الجنيني',
      en: 'Measurement of alpha-fetoprotein',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '48 ساعة',
      en: '48 hours',
    },
  },
  // Additional Cardiac Tests
  {
    id: 100,
    name: {
      ar: 'تحليل CK-MB',
      en: 'CK-MB Test',
    },
    shortcutName: 'CK-MB',
    category: {
      ar: 'تحاليل القلب والكولسترول',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس إنزيم CK-MB للكشف عن النوبات القلبية',
      en: 'Measurement of CK-MB enzyme to detect heart attacks',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 101,
    name: {
      ar: 'تحليل Troponin',
      en: 'Troponin Test',
    },
    shortcutName: 'Troponin',
    category: {
      ar: 'تحاليل القلب والكولسترول',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس التروبونين للكشف عن النوبات القلبية',
      en: 'Measurement of troponin to detect heart attacks',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24 ساعة',
      en: '24 hours',
    },
  },
  {
    id: 102,
    name: {
      ar: 'تحليل BNP',
      en: 'BNP (Brain Natriuretic Peptide)',
    },
    shortcutName: 'BNP',
    category: {
      ar: 'تحاليل القلب والكولسترول',
      en: 'Cardiac Tests',
    },
    description: {
      ar: 'قياس الببتيد المدر للصوديوم الدماغي',
      en: 'Measurement of brain natriuretic peptide',
    },
    preparation: {
      ar: 'لا يحتاج صيام',
      en: 'No fasting required',
    },
    turnaroundTime: {
      ar: '24-48 ساعة',
      en: '24-48 hours',
    },
  },
];

